import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const GET_MULTIPLE_CLIENTS_REPORT = createAsyncActionType('GET_MULTIPLE_CLIENTS_REPORT');

export const EXPORT_MULTIPLE_CLIENT_REPORT_PDF = createAsyncActionType('EXPORT_MULTIPLE_CLIENT_REPORT_PDF');

export const EXPORT_MULTIPLE_CLIENT_REPORT_HTML = createAsyncActionType('EXPORT_MULTIPLE_CLIENT_REPORT_HTML');


export const SET_MULTIPLE_CLIENTS_REPORT_FILTERS = 'SET_MULTIPLE_CLIENTS_REPORT_FILTERS';

export const CLEAR_MULTIPLE_CLIENTS_REPORT = 'CLEAR_MULTIPLE_CLIENTS_REPORT';


export const CLEAR_MULTIPLE_CLIENTS_REPORT_HTML = 'CLEAR_MULTIPLE_CLIENTS_REPORT_HTML';

export const CLEAR_MULTIPLE_CLIENTS_REPORT_PDF = 'CLEAR_MULTIPLE_CLIENTS_REPORT_PDF';

export const FORCE_IS_LOADING_FALSE_EXPORT_PDF = 'FORCE_IS_LOADING_FALSE_EXPORT_PDF';

export const FORCE_IS_LOADING_FALSE_EXPORT_HTML = 'FORCE_IS_LOADING_FALSE_EXPORT_HTML';


// WEBPACK FOOTER //
// ./src/features/reports/types/multipleClientsReportType.js